export const ROLES = {
    Admin: "ROLE_ADMIN",
    Analyst: "ROLE_ANALYST",
    Editor: "ROLE_EDITOR",
    SuperAdmin: "ROLE_SUPER_ADMIN"
}

